import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import { ucwords } from '../../../../../applications/helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function UpdateModal({
  updateNewBusinessActivities,
  getSingleNewBusinesses,
  id,
  isBusinessLineIdLoading,
  getNecessaryFieldsList,
  necessaryFieldsList,
  businessActivitiesId,
  businessActivitiesInfo,
  getBusinessLinesList,
  businessLinesList,
  updating,
  updateList,
}) {
  const setModal = useContext(ModalContext);
  const [formDetails, setFormDetails] = useState({});
  const [multiplierData, setMultiplierData] = useState({});
  const permissions = getJson('permissions');
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});
  const filteredNecessaryFieldsList = necessaryFieldsList.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = necessaryFieldsList.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const quantityMatrix = _.get(businessActivitiesInfo, 'attributes.details.quantity_matrix', {});
  const multiplierQuantityMatrix = Object.entries(quantityMatrix).reduce((acc, [, items]) => {
    items.forEach(({ multiplier, value }) => {
      acc[multiplier] = value;
    });
    return acc;
  }, {});

  const [formData, setFormData] = useState({
    business_line_id: '',
    capital_amount: '',
    gross_amount: '',
  });

  const commonValidation = {
    business_line_id: 'required',
    capital_amount: 'required|number',
    gross_amount: 'required|number',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    getBusinessLinesList();
  }, []);

  useEffect(() => {
    if (_.get(businessActivitiesInfo, 'attributes.business_line_id')) {
      const args = {
        business_line_id: _.get(
          businessActivitiesInfo,
          'attributes.business_line_id'
        ),
        application_status_id: 0,
      };

      getNecessaryFieldsList(args);
    }
  }, [_.get(businessActivitiesInfo, 'attributes.business_line_id')]);

  const validateMultiplier = Object.keys(formDetails || {})
    .map((item) => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateMultiplier = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateMultiplier) {
      setMultiplierData((prevData) => ({
        ...prevData,
        ...value,
      }));
    }
  };

  const validateFormMultiplier = useFormValidator(formDetails, multiplierData);

  useEffect(() => {
    setValidateMultiplier();
  }, [formDetails, _.get(formData, 'business_line_id')]);

  useEffect(() => {
    validateFormMultiplier.onSetObjectRules(multiplierData);
  }, [multiplierData, formDetails]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const combinedDetails = {
      ...formDetails,
      quantity_matrix: formDataQuantityMatrix,
    };

    const args = {
      business_line_id: _.get(formData, 'business_line_id'),
      capital_amount: _.get(formData, 'capital_amount'),
      gross_amount: _.get(formData, 'gross_amount'),
      override_amount: _.get(formData, 'override_amount'),
      details: combinedDetails,
    };

    updateNewBusinessActivities(id, businessActivitiesId, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(id);
      setFormDataQuantityMatrix({});
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(businessActivitiesInfo)) {
      setFormDataQuantityMatrix({
        ...formDataQuantityMatrix,
        ...multiplierQuantityMatrix,
      });
    }
  }, []);

  useEffect(() => {
    let keyValues = [];
    const details = _.get(businessActivitiesInfo, 'attributes.details')
      ? _.get(businessActivitiesInfo, 'attributes.details')
      : '';
    keyValues = Object.entries(details).map(([key, value]) => ({
      [key]: value.toString(),
    }));
    let finalObject = {};
    const badCallback = (a, i) => Object.assign(a, i);
    finalObject = keyValues.reduce(badCallback, {});

    setFormDetails({
      ...formDetails,
      ...finalObject,
    });
  }, []);

  // select line
  const handleLineDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    setFormDetails();

    const args = {
      business_line_id: e ? e.value : '',
      application_status_id: 0,
    };

    getNecessaryFieldsList(args);
  };

  const onSelectDetails = (key) => (e) => {
    setFormDetails({
      ...formDetails,
      [key]: e ? e.value : '',
    });
  };

  const onChangeQuantityMatrix = (e) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [e.target.name]: e ? +e.target.value : '',
    });
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const selectBusinessLineId = businessLinesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessLineValue =
    selectBusinessLineId.find(
      (item) =>
        _.get(formData, 'business_line_id')?.toString() === item.id?.toString()
    ) || '';

  const selectOptions = (list) => {
    const newList = [];

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  useEffect(() => {
    if (!formDetails) return;
    const calculateTotalGrossAmount = () => {
      if (!formDetails) return 0;

      return Object.keys(formDetails)
        .filter((key) => key.includes('gross_amount'))
        .reduce((total, key) => {
          const amount = parseFloat(formDetails[key]) || 0;
          return total + amount;
        }, 0);
    };

    setFormData({
      ...formData,
      gross_amount:
        calculateTotalGrossAmount() || _.get(formData, 'gross_amount'),
    });
  }, [JSON.stringify(formDetails)]);

  useEffect(() => {
    validateFormMultiplier.validate();
  }, [
    Object.keys(formDetails || {}).join(','),
    Object.values(formDetails || {}).join(','),
  ]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.BUSINESS_ACTIVITIES_FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const hasGrossAmount = necessaryFieldsList.some((item) =>
    _.get(item, 'multiplier', '').includes('gross_amount')
  );

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Business Line: {validateForm.renderMessage('business_line_id')}
            </label>
            <Select
              options={selectBusinessLineId}
              isLoading={isBusinessLineIdLoading}
              value={findBusinessLineValue}
              onChange={handleLineDropDownChange('business_line_id')}
              isClearable
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Capital Amount: {validateForm.renderMessage('capital_amount')}
            </label>
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                setFormData({
                  ...formData,
                  capital_amount: value,
                });
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'capital_amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Gross Amount: {validateForm.renderMessage('gross_amount')}
            </label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                setFormData({
                  ...formData,
                  gross_amount: value,
                });
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'gross_amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
              disabled={hasGrossAmount}
            />
          </div>
          {Acl(permissions, ['OVERRIDE BPLS AMOUNT']) && (
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label">
                Override Minimum Amount &nbsp;
              </label>
              <input
                name="override_amount"
                type="checkbox"
                checked={_.get(formData, 'override_amount') || 0}
                onChange={onCheck}
              />
            </div>
          )}
          <div className="col-12 form-group">
            {(filteredNecessaryFieldsList || [])?.map((item) => {
              const multiplier = _.get(item, 'multiplier', '');
              const options = _.get(item, 'options');
              const label = ucwords(multiplier?.replace(/_/g, ' '));
              const validationMsg =
                validateFormMultiplier.renderMessage(multiplier);
              const hasGrossKey = multiplier.includes('gross_amount_');

              if (options) {
                return (
                  <React.Fragment key={multiplier}>
                    <label className="form-label">
                      {label} {validationMsg}
                    </label>
                    <Select
                      onChange={onSelectDetails(multiplier)}
                      options={selectOptions(options)}
                      isClearable
                      value={
                        selectOptions(options).find(
                          (option) =>
                            _.get(formDetails, multiplier) ===
                            _.get(option, 'value')
                        ) || ''
                      }
                    />
                  </React.Fragment>
                );
              }

              return (
                <React.Fragment key={multiplier}>
                  <label className="form-label">
                    {label} {validationMsg}
                  </label>

                  <NumberFormat
                    name={multiplier}
                    id={multiplier}
                    placeholder="0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { value } = values;
                      setFormDetails({
                        ...formDetails,
                        [multiplier]: value,
                      });
                    }}
                    displayType="input"
                    decimalScale={2}
                    isNumericString
                    allowNegative
                    thousandSeparator
                    allowLeadingZeros
                    prefix={hasGrossKey ? '₱ ' : ''}
                    value={_.get(formDetails, multiplier)}
                    isAllowed={(values) => {
                      const { value } = values;
                      if (!hasGrossKey || !value) return true;
                      const val = new Decimal(value);
                      const max = new Decimal(MAX_LIMIT);
                      return value === undefined || val.lte(max);
                    }}
                  />
                </React.Fragment>
              );
            })}
          </div>
          {!_.isEmpty(filteredQuantityMatrix) ? (
            filteredQuantityMatrix.map((item) => {
              const multiplier = _.get(item, 'multiplier', '');
              
              return (
                <React.Fragment>
                  <div className='form-group col-12 mb-0'>
                    <label className='form-label mb-0 text-capitalize'>
                      {multiplier}
                    </label>
                  </div>
                  <div className="w-100 border rounded-lg mx-3">
                    <table className="table table-borderless table-sm table-striped table-hover mb-0">
                      <thead>
                        <tr className="form-group">
                          <td className="col-4 form-label text-center border-right">Unit</td>
                          <td className="col-4 form-label text-center border-right">Capacity</td>
                          <td className="col-4 form-label text-center">Number of Units</td>
                        </tr>
                      </thead>
                      <tbody>
                        {item.quantity_matrix.map((quantityMatrixItem) => {
                          const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                          return (
                            <tr key={quantityMatrixMultiplier} className="border-top form-group">
                              <td className="col-4 text-left form-label border-right">
                                {_.get(quantityMatrixItem, 'unit')}
                              </td>
                              <td className="col-4 text-left form-label border-right">
                                {_.get(quantityMatrixItem, 'capacity')}
                              </td>
                              <td className="col-4 text-left form-label">
                                <input
                                  className="form-control"
                                  type="text"
                                  name={quantityMatrixMultiplier}
                                  onChange={onChangeQuantityMatrix}
                                  value={_.get(
                                    formDataQuantityMatrix,
                                    `${quantityMatrixMultiplier}`,
                                    ''
                                  )}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              )
            })
          ) : (
            ''
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={updating || !validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.defaultProps = {
  isBusinessLineIdLoading: false,
};

UpdateModal.propTypes = {
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updateNewBusinessActivities: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  isBusinessLineIdLoading: PropTypes.bool,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  businessActivitiesId: PropTypes.string.isRequired,
  businessActivitiesInfo: PropTypes.instanceOf(Object).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isBusinessLineIdLoading:
    _.get(api, 'loading', []).indexOf(c.GET_NEW_BUSINESS_LINE_ID) > -1,
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_NEW_BUSINESS_ACTIVITIES) > -1,
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
